






















































































































































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import Bus from "@/JS/Bus";
import HttpClient from "@/API/HttpClient";
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import httpApi from "@/API/Tenant/Weixin";
@Component({
  components: {}
})
export default class extends Vue {
  private form: any = {};
  private tableData: any = [];
  private WxQrCode: any;
  private scrollHeight = 600; //当前高度
  private dialogVisible = false;
  private onModifyVisible = false;
  private textarea = "";
  private listdata: any = [];
  private loadData: any = {};
  private modelData: any = {};
  private loading = false;
  private nickName = "";
  private Winning = "";
  private pages: any = {
    page: 0,
    rows: 10
  };
  created() {
    this.WxQrCode = localStorage.getItem("WxQrCode");
    this.prizeList(this.WxQrCode);
  }
  computed() {
    this.noMore();
    this.disabled();
  }
  noMore() {
    return this.listdata.length >= 20;
  }
  disabled() {
    return this.loading || this.noMore;
  }

  //格式化是否显示
  formatStatus(row: any, column: any) {
    switch (row.Status) {
      case 0:
        return "作废";
        break;
      case 1:
        return "未领取";
        break;
      case 2:
        return "已领取";
        break;
      default:
        return "";
        break;
    }
  }
  load() {
    this.loading = true;
    setTimeout(() => {
      // this.listdata.length += 2;
      this.pages.page++;
      this.getMessageRecordList(this.loadData);
      this.loading = false;
    }, 2000);
  }
  async SendWxText() {
    //console.log(this.loadData);
    let params: any = {
      Input: [
        {
          Name: "AppReplyRecordDTO",
          Value: {
            TenantId: this.loadData.TenantId,
            ApplicationId: this.loadData.Aid,
            Keyword: this.textarea,
            OpenId: this.loadData.OpenId,
            Type: 2,
            Reads: false
          }
        }
      ]
    };
    //console.log(params);
    this.loading = true;
    var res: any = await httpApi.SendWxText(params);
    //console.log(res);
    if (res.ErrorCode == 0) {
      this.textarea = "";
      this.refresh();
    } else {
      this.$message.error("发送消息失败：" + res.ErrorMessage);
      this.loading = false;
    }
  }
  refresh() {
    this.listdata = [];
    this.loading = true;
    this.pages.page = 0;
    this.getMessageRecordList(this.loadData);
    this.loading = false;
  }
  onModify(data: any) {
    this.modelData = data;
    this.onModifyVisible = true;
    this.nickName = data.NickName;
  }
  //保存核销数据
  async SaveWxQrCodeReservation() {
    let params: any = {
      Input: [
        {
          Name: "model",
          Value: this.modelData
        }
      ]
    };
    console.log(params);
    var res: any = await httpApi.SaveWxQrCodeReservation(params);
    console.log(res);

    if (res.ErrorCode == 0) {
      this.onModifyVisible = false;
      this.prizeList(this.WxQrCode);
    } else {
      this.$message.error("保存失败：" + res.ErrorMessage);
    }
  }
  async getMessageRecordList(data: any) {
    let params: any = {
      Input: [
        {
          Name: "AppReplyRecordDTO",
          Value: {
            TenantId: data.TenantId,
            OpenId: data.OpenId,
            ApplicationId: data.Aid,
            Type: -1
          }
        },
        {
          Name: "page",
          Value: this.pages
        }
      ]
    };
    console.log(params);

    var res: any = await httpApi.MessageRecordList(params);
    //console.log(res);
    if (res.ErrorCode == 0) {
      // this.listdata = res.output[0].value;
      let datalist = res.output[0].value;
      //console.log(datalist);

      datalist.forEach((el: any) => {
        console.log(el);
        this.listdata.push(el);
      });
      //push
    } else {
      this.$message.error("读取列表失败：" + res.ErrorMessage);
    }
  }
  //弹出聊天对话框
  awardNotice(data: any) {
    this.Winning =
      HttpClient.ServerWxHost() +
      "/poster/wx-yuyue.html?posterid=" +
      localStorage.getItem("PosterDataId") +
      "&tenantid=" +
      getCookie("TenantID") +
      "&openid=" +
      data.OpenId;
    this.nickName = data.NickName;
    this.dialogVisible = true;
    console.log(data);
    this.listdata = [];
    this.getMessageRecordList(data);
    this.loadData = data;
    // this.getMessageRecordList(data);
  }
  //刷新领奖数据
  RefreshPrize() {
    this.prizeList(this.WxQrCode);
  }
  //查询数据列表
  async prizeList(WxQrCode: any) {
    this.form.TenantId = getCookie("TenantID");
    this.form.Aid = getCookie("Aid");
    this.form.PosterId = WxQrCode; // getCookie("WxQrCode");
    let params: any = {
      Input: [
        {
          Name: "model",
          Value: this.form
        }
      ]
    };
    var res: any = await httpApi.GetWxQrCodeReservationList(params);
    console.log(res);
    if (res.ErrorCode == 0) {
      this.tableData = res.output[0].value;
    } else {
      this.$message.error("查询数据列表失败：" + res.ErrorMessage);
    }
  }
  //取消方法
  cancle() {
    this.$emit("formData", {
      pagename: "listForm",
      WxQrCodePosterList: [],
      WxQrCodePosterDetail: {},
      page: 1
    });
  }
}
